<template>
  <div class="application-scenario">
    <h2 class="title">应用场景</h2>
    <div class="tabs">
      <button v-for="(tab, index) in tabs" :key="index" :class="{ active: activeTab === index }"
        @click="handleTabClick(index)">
        {{ tab.name }}
      </button>
    </div>
    <div class="tab-content">
      <img :src="tabs[activeTab].image" :alt="tabs[activeTab].name"
        :style="{ 'height': tabs[activeTab].name === '病虫害治理' ? '640PX' : '' }" />
      <p class="text">{{ tabs[activeTab].description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationScenario',
  data() {
    return {
      currentSource: '', // 用于存储当前的 source 参数
      activeTab: 0,
      tabs: [],
    };
  },
  created() {
    this.updateImgList();
    this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
  },
  watch: {
    // 监听 URL 的变化
    '$route.fullPath': {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get('source');
        // if (source !== this.currentSource) {
        this.currentSource = source;
        this.updateImgList();
        // }
      },
    },
  },
  methods: {
    updateImgList() {
     
      switch (this.currentSource) {
        case 'industry_safety_1':
          this.activeTab = 0
          this.tabs = [
            {
              name: '重点巡检',
              image: 'https://hr2.chnsoft.com.cn/img/重点巡检.jpg',
              description: '对于工业园区、交通枢纽、校园周边等重点区域，华软地空协同智能航空站（自动机场）系列产品及智能全域巡视系统，可全自动开展无人机维保、高频巡查、可疑识别、取证留存、报告生成等各项任务，降低人员需求，显著提升执法效率。',
            },
            {
              name: '大型安保',
              image: 'https://hr2.chnsoft.com.cn/img/大型安保.jpg',
              description: '在赛事活动、演唱会等人群稠密、人流量大的场景，华软无人装备指挥车、地空协同智能航空站（自动机场）、无人机系留供电系统等，在区域巡查持续性、巡查效率、巡查准确度等方面全面断层式领先于传统人工巡查、摄像头监控、飞手遥控无人机等传统方式。',
            },
            {
              name: '要地守护',
              image: 'https://hr2.chnsoft.com.cn/img/应急处突.jpg',
              description: '边境线、水库电站、油气管道等复杂地形场景中，华软无人化智能航空站全天候保障无人机作业能力，指挥无人机高频、高效完成巡查巡检，智能识别风险隐患、自动生成报告。',
            },
            {
              name: '追踪侦查',
              image: 'https://hr2.chnsoft.com.cn/img/要地守护.png',
              description: '华软移动航空站、集控地面站等系列产品，可高效控制无人机对嫌疑人/ 车辆动态锁定，结合人脸识别、车牌识别技术，实现跨区域协同围捕。',
            },

          ]
          break;
        case 'industry_safety_2':
          this.activeTab = 0
          this.tabs = [
            {
              name: '灾情全域侦察',
              image: 'https://hr2.chnsoft.com.cn/img/灾情全域侦察.jpg',
              description: '在洪涝、地震等灾害发生后，华软地空协同智能航空站（自动机场）系列产品可保障无人机、机器人第一时间出击。依托华软智能全域巡视系统快速建模功能，在极短时间内完成现场建模，配合实时回传的高清影像，精准识别受灾区域及次生灾害风险，为指挥层提供快速、直观、动态更新的数据支撑。',
            },
            {
              name: '应急通信中继',
              image: 'https://hr2.chnsoft.com.cn/img/应急通信中继.png',
              description: '华软智能全域巡视系统可集群控制多架搭载基站的无人机快速组网，构建灾区临时通信链路，保障救援指令及灾民求救信息实时传输。',
            },
            {
              name: '指挥决策支撑',
              image: 'https://hr2.chnsoft.com.cn/img/指挥决策支撑.jpg',
              description: '华软无人装备指挥车、无人装备便携地面站集群控制多架无人机联动集群作业，全域覆盖灾害现场，支撑指挥部动态部署人员物资与救援路径规划。',
            },
            {
              name: '无人智能处置',
              image: 'https://hr2.chnsoft.com.cn/img/无人化处置.png',
              description: '华软陆空协同消防系列产品，通过地面无人消防机器人与空中消防无人机立体协同，第一时间抵达火场抢占黄金灭火时间，无需人员直接介入，保障救援人员安全。',
            },
            {
              name: '紧急物资投送',
              image: 'https://hr2.chnsoft.com.cn/img/紧急物资投送.png',
              description: '华软大载重智能航空站系列产品可自动保障运输无人机稳定、高效突破交通中断区域，精准空投急救药品、救生设备，缩短生命救援响应周期。',
            },
          ]
          break;
        case 'industry_power_1':
          this.activeTab = 0
          this.tabs = [
            {
              name: '杆塔巡检',
              image: 'https://hr2.chnsoft.com.cn/img/杆塔精细化检测.png',
              description: '华软移动航空站和无人装备指挥车机动能力强、作业范围大、无人机收放自动化程度高，借助行业大模型和华软智能大脑的卓越算力，快速识别杆塔结构、部件问题，支持无人机自动跟随与“A起B降”，高效完成长距离线路杆塔精细化巡检。',
            },
            {
              name: '红外测温',
              image: 'https://hr2.chnsoft.com.cn/img/红外测温.jpg',
              description: '华软移动航空站和垂起固定翼航空站广泛应用于高压输电红外测温场景，放飞搭载高精度红外测温仪的无人机，快速获取设备温度，结合华软智能大脑的强大算力进行精准分析，及时发现过热隐患，保障输电设备安全运行。',
            },
            {
              name: '通道巡检',
              image: 'https://hr2.chnsoft.com.cn/img/tongdaojiance.png',
              description: '华软移动航空站和垂起固定翼航空站广泛应用于高压输电通道巡检场景，放飞的无人机搭载双光镜头，结合华软智能大脑的强大算力进行快速分析，及时发现走廊施工、异物入侵等安全隐患。',
            },
            {
              name: '树障巡检',
              image: 'https://hr2.chnsoft.com.cn/img/树障巡检.jpg',
              description: '华软移动航空站和垂起固定翼航空站广泛应用于高压输电树障巡检场景，通过高清摄像头与热成像设备，清晰判别树木与线路的位置关系。依托大模型及华软智能大脑的卓越算力，自动识别树障风险，提前预警，助力及时除障，保障长距离输电不受树障干扰。',
            },
          ]
          break;
        case 'industry_power_2':
          this.activeTab = 0
          this.tabs = [
            {
              name: '设备精细化巡检',
              image: 'https://hr2.chnsoft.com.cn/img/设备精细化巡检.png',
              description: '地空协同智能航空站（自动机场）凭借高电磁兼容适应性、超高稳定性、全天候保障作业能力，广泛应用于变电（换流）站的精细化巡检场景，全自动换电能力及集群协同作业能力保障了24小时不间断、高强的巡检效能，依托行业大模型及华软智能大脑的卓越算力，高效、准确地完成精细化巡检任务，保障供电稳定性。',
            },
            {
              name: '室内设施巡检',
              image: 'https://hr2.chnsoft.com.cn/img/室内设施巡检.png',
              description: '华软地空协同智能航空站（自动机场），基于激光SLAM、UWB、机器视觉等技术深度融合，实现变电（换流）站GIS室、调相机室等室内GNSS拒止环境下无人机自主巡检。室内设施巡检效能和准确性处于行业绝对领先地位。',
            },
            {
              name: '设备应用抢修',
              image: 'https://hr2.chnsoft.com.cn/img/设备应用抢修.png',
              description: '华软地空协同智能航空站（自动机场）和智能全域巡视系统凭借精准的“指点飞行”功能和智能航线规划及避障能力，可配合专业维护人员，近距离多角度观察设备细节，为维护提供实时画面，辅助精准操作，提升设备维护质量和效率。',
            },
            {
              name: '场站建设监管',
              image: 'https://hr2.chnsoft.com.cn/img/场站建设监管.jpg',
              description: '地空协同智能航空站（自动机场）和智能全域巡视系统凭借快速建模、精准建模、高清图像实时回传能力，对新建变电（换流）站进行高效巡检，全面核查场站建设进度、设备安装情况、人员安全状态，为监管人员提供客观、准确的数据依据。',
            },
          ]
          break;
        case 'industry_power_3':
          this.activeTab = 0
          this.tabs = [
            {
              name: ' 配电设备巡检',
              image: 'https://hr2.chnsoft.com.cn/img/配电设备巡检.jpg',
              description: '华软无人装备便携地面站，凭借轻巧便携、多机集控、高电磁兼容适应性、超高稳定性、全天候作业能力，广泛应用于配电设备巡检工作中，具有费用低、人员占用少、巡检效率高、环境适应性强等特点。 ',
            },
            {
              name: ' 电缆状态监测',
              image: 'https://hr2.chnsoft.com.cn/img/电缆状态监测.jpg',
              description: '华软移动航空站搭载无人机，配备高清可见光与热成像摄像头，可对配电电缆进行细致巡检。搭载的算力单元结合行业大模型，精准分析电缆发热等异常，快速定位问题，确保电缆运行状态尽在掌握。',
            },
            {
              name: '台区树障治理',
              image: 'https://hr2.chnsoft.com.cn/img/树障治理.jpg',
              description: '华软移动航空站和垂起固定翼智能航空站广泛应用于配电网络台区树障巡检场景，通过高清摄像头与热成像设备，清晰判别树木与线路的位置关系。依托行业大模型及华软智能大脑的卓越算力，自动识别台区树障风险，提前预警，助力及时除障，保障配电网络不受树障干扰。',
            },
            {
              name: '应急灾损评估',
              image: 'https://hr2.chnsoft.com.cn/img/应急灾损评估.jpg',
              description: '地空协同智能航空站（自动机场）和智能全域巡视系统凭借无人机快速建模功能，快速呈现灾后配电网络三维地图，辅助灾情评估及复电方案。',
            },
          ]
          break;
        case 'industry_power_4':
          this.activeTab = 0
          this.tabs = [
            {
              name: '室内巡检',
              image: 'https://hr2.chnsoft.com.cn/img/室内巡检.jpg',
              description: '轻量化无人机智能机场＋室内无人机自主定位导航，可在阀厅、GIS室、调相机室等室内场景灵活作业，精准监测设备状态，及时发现潜在问题。',
            },
            {
              name: '室外巡检',
              image: 'https://hr2.chnsoft.com.cn/img/室外巡检.jpg',
              description: '双机系列智能机场高效执行换流变、直流场、交流场等场景无人自主巡检。独特的双机协同作业体系满足不间断空中监视、一键顺控等辅助作业。',
            },
            {
              name: '室内应急',
              image: 'https://hr2.chnsoft.com.cn/img/室内应急.jpg',
              description: '应急处置机器人结合空中无人机与地面机器人，实现阀厅内高低空设备智能消防作业，快速响应火灾，精准灭火，保障设施安全。',
            },
            {
              name: '室外应急',
              image: 'https://hr2.chnsoft.com.cn/img/室外应急.jpg',
              description: '无人驾驶消防车能够在换流站室外迅速就位，利用其搭载的先进灭火设施快速抑制火势蔓延，避免人员直接面临危险，保障应急处理的高效与安全。',
            },
          ]
          break;
        case 'industry_energy_1':
          this.activeTab = 0
          this.tabs = [
            {
              name: '组件巡检',
              image: 'https://hr2.chnsoft.com.cn/img/组件巡检.jpg',
              description: '地空协同智能航空站（自动机场）凭借快速换电及全天候作业保障能力，可随时开展高强度、不间断的无人装备巡检作业。无人机与四足机器人、无人船等集群协同作业，高效覆盖大片组件。借助行业大模型与全国产化智能大脑的卓越算力，快速识别组件表面热斑、隐裂、破损等问题，精准定位缺陷。',
            },
            {
              name: '线路巡检',
              image: 'https://hr2.chnsoft.com.cn/img/线路巡检.jpg',
              description: '地空协同智能航空站（自动机场）可智能规划巡检线路，让无人机对场站内线路进行精细化巡检。面对可能出现的高隐蔽性线路问题，华软无人机载带电线路X光自适应探伤系统可对线路进行精准探伤，通过X光技术和人工智能算法，自动识别并标记潜在缺陷或损伤点，为后续的维修或更换工作提供重要依据。',
            },
            {
              name: '热斑检测',
              image: 'https://hr2.chnsoft.com.cn/img/热斑检测.jpg',
              description: '地空协同智能航空站（自动机场）利用无人机热成像技术，对光伏组件进行热斑检测。凭借自动机场强大稳定的无人装备任务保障能力，能快速扫描大面积区域。结合强大算力与算法，精准捕捉热斑异常温度，及时预警，避免热斑损坏组件，延长组件使用寿命。',
            },
            {
              name: '电站运维',
              image: 'https://hr2.chnsoft.com.cn/img/电站运维.jpg',
              description: '智能全域巡视系统整合华软各型智能航空站、光伏清洗机器人，统一调度管理。无人机、机器人协同巡检作业，全面掌握电站设备状态、提升发电效率。借助大数据分析，提前预判故障，合理规划运维任务，提高运维效率，降低运维成本。',
            },
            {
              name: '背板巡检',
              image: 'https://hr2.chnsoft.com.cn/img/背板巡检.png',
              description: '陆地光伏依靠华软空地一体母站出动四足机器人，灵活穿梭检测背板情况。水上光伏则由智能无人船搭载设备完成巡检。它们能近距离、细致地查看背板磨损、老化等问题。通过实时数据传输与分析，及时发现隐患，确保背板长期可靠，适应不同场景。',
            },
          ]
          break;
        case 'industry_energy_2':
          this.activeTab = 0
          this.tabs = [
            {
              name: '风机叶片巡检',
              image: 'https://hr2.chnsoft.com.cn/img/风机叶片巡检.jpg',
              description: '华软移动航空站与无人装备指挥车，凭借搭载无人机的高清摄像头与热成像设备，贴近风机叶片细致巡检。借助算力单元与 AI 算法，精准识别叶片裂纹、腐蚀及异物附着，多机协同快速完成大面积巡检，及时发现隐患，保障叶片安全运行。',
            },
            {
              name: '塔筒基础检查',
              image: 'https://hr2.chnsoft.com.cn/img/塔筒基础检查.jpg',
              description: '利用移动航空站及无人装备指挥车，无人机快速抵达塔筒基础位置。无人机搭载的专业检测设备，能清晰捕捉基础表面状况。依托强大算力分析，迅速判定是否存在裂纹、腐蚀及异物附着问题，为塔筒基础稳定提供可靠监测，降低安全风险。',
            },
            {
              name: '海上风机基础巡检',
              image: 'https://hr2.chnsoft.com.cn/img/海上风机基础巡检.png',
              description: '华软海空协同无人船放飞无人机，抵近塔筒自主巡航。无人机利用其高清变焦相机与热成像仪，精准检测表面涂层损伤与基础冲刷情况。无人化自主巡检，适应恶劣海上环境，海空协同高效获取准确数据。',
            },
            {
              name: '应急响应评估',
              image: 'https://hr2.chnsoft.com.cn/img/yingJiXiang.jpg',
              description: '灾害发生时，华软各型地空协同智能航空站（自动机场）凭借内置不间断电源(UPS)保障，立即放飞无人机对风力发电场进行监测与建模。无人机提供清晰空中视角，助力指挥中心全面掌握现场情况，快速制定最佳应对策略，高效开展应急救援与修复工作。',
            },
          ]
          break;
        case 'industry_energy_3':
          this.activeTab = 0
          this.tabs = [
            {
              name: '大坝周边巡检',
              image: 'https://hr2.chnsoft.com.cn/img/大坝周边巡检.jpg',
              description: '部署地空协同智能航空站（自动机场）与海空协同无人船，构建立体巡检体系。由无人机与无人船，通过高清摄像头、红外热像仪等设备，在大坝周边开展海空协同巡航。利用华软全国产化“智能大脑”提供的强大算力与多种AI算法，快速识别坝体裂缝、泥沙淤积、变形沉降、渗漏迹象及周边异物，全面保障大坝安全。',
            },
            {
              name: '水域安全巡查',
              image: 'https://hr2.chnsoft.com.cn/img/水域安全巡检.jpg',
              description: '部署海空协同无人船，由无人机进行高空广域扫描，无人船负责水面细致排查。通过搭载多种探测设备，实时监测水域船只、人员活动，及时发现异常，预防溺水、非法闯入等安全事故，守护水域安全。',
            },
            {
              name: '发电机组检查',
              image: 'https://hr2.chnsoft.com.cn/img/发电机组巡检.jpg',
              description: '地空协同智能航空站（自动机场）放飞无人机搭载专业检测任务载荷，结合多种AI算法对厂房结构、变压器油位与渗漏、绝缘子破损、线路异常等进行精细化巡检与智能分级预警。无人船配备传感器和高清摄像头，可进入狭窄空间，探测水轮机叶片是否存在气蚀、腐蚀、裂纹和冲击伤痕等，并在复杂水流环境中完成水下地形测绘与表观缺陷检测。',
            },
            {
              name: '应急响应评估',
              image: 'https://hr2.chnsoft.com.cn/img/应急响应评估.jpg',
              description: '在因灾害导致电力中断时，华软地空协同智能航空站可依靠内部UPS不间断电源立即放飞无人机，采集现场影像并快速生成实景三维模型。智能全域巡视系统整合多方数据，为指挥中心提供全面、实时的态势信息，辅助制定科学救援与修复方案，高效应对突发状况。',
            },
            {
              name: '水质水文监测',
              image: 'https://hr2.chnsoft.com.cn/img/水质水文监测.png',
              description: '海空协同无人船搭载多参数水质在线监测仪、声学多普勒流速剖面仪（ADCP）、多点分层采样器等专业设备，在不同水域深度与位置自动采集样本与数据，实时监测水质变化与水流速度，为水力发电的调度与环保管理提供精准数据支撑。',
            },
          ]
          break;
        case 'industry_energy_4':
          this.activeTab = 0
          this.tabs = [
            {
              name: '油田巡检',
              image: 'https://hr2.chnsoft.com.cn/img/油田巡检.jpg',
              description: '地空协同智能航空站放飞无人机，凭借高清及热成像设备，覆盖大片油田区域。集群协同作业，快速扫描抽油机、井口等设备。借助AI与算力单元，自动识别设备异常，如泄漏、部件损坏，及时预警，保障油田稳定生产。',
            },
            {
              name: '管道监测',
              image: 'https://hr2.chnsoft.com.cn/img/管道监测.jpg',
              description: '移动航空站与无人装备指挥车，沿输油管道机动巡检。无人机按预设航线飞行，搭载热成像与气体检测仪等。通过智能分析，能精准发现管道腐蚀、泄漏迹象，快速定位问题点，降低安全风险，确保管道安全运行。',
            },
            {
              name: '储罐检查',
              image: 'https://hr2.chnsoft.com.cn/img/储罐检查.jpg',
              description: '华软地空协同智能航空站放飞无人机，搭载的高清相机与传感器，对罐体外观、液位等全面检测。利用华软智能算法，快速判断罐体是否有腐蚀、变形等情况，准确掌握储罐状态，保障油品储存安全。',
            },
            {
              name: '应急响应',
              image: 'https://hr2.chnsoft.com.cn/img/应急响应.png',
              description: '应急场景下，华软地空协同智能航空站搭载的无人机迅速升空，采集现场数据并建模。提供实时空中视角，助力指挥中心掌握火势、泄漏范围等。智能全域巡视系统整合信息，辅助制定高效应对策略，提升应急处理效率。',
            },
          ]
          break;
        case 'industry_energy_5':
          this.activeTab = 0
          this.tabs = [
            {
              name: '场站巡检',
              image: 'https://hr2.chnsoft.com.cn/img/场站巡检.png',
              description: '华软地空协同智能航空站调度无人机，迅速全面覆盖天然气场站。搭载的高清摄像头与气体检测仪，可精准捕捉设备细节与气体泄漏情况。依托强大算力单元与AI技术，快速识别设备异常与安全隐患，确保场站运行安全，降低人力巡检成本与风险。',
            },
            {
              name: '管道监测',
              image: 'https://hr2.chnsoft.com.cn/img/管道监测.jpg',
              description: '移动航空站与无人装备指挥车，沿天然气管道机动巡检。无人机搭载热成像与气体检测仪等。通过智能分析，能精准发现管道腐蚀、泄漏迹象，快速定位问题点，降低安全风险，确保管道安全运行。',
            },
            {
              name: '储罐检查',
              image: 'https://hr2.chnsoft.com.cn/img/储罐检查.jpg',
              description: '华软地空协同智能航空站调度无人机围绕天然气储罐精细巡检，利用双光镜头及气体检测仪等，对罐体外观、温度分布进行全面检测。借助先进算法，快速诊断罐体是否存在裂缝、老化等安全隐患，准确评估储罐状态，为天然气储存安全保驾护航。',
            },
            {
              name: '应急响应',
              image: 'https://hr2.chnsoft.com.cn/img/应急响应图.jpg',
              description: '天然气出现紧急状况时，华软地空协同智能航空站立刻放飞无人机，快速获取现场高清影像与数据。智能平台整合信息，为指挥中心提供实时、全面态势感知，辅助制定科学有效的应急策略，提升应急救援效率与准确性。',
            },
          ]
          break;

        case 'industry_other_1':
          this.activeTab = 0
          this.tabs = [
            {
              name: '接触网巡检',
              image: 'https://hr2.chnsoft.com.cn/img/接触网巡检.jpg',
              description: '通过红外热成像仪和高清摄像头，检测接触网温度分布及零部件状态，及时发现过热、松动、断裂等隐患，保障供电系统稳定运行。',
            },
            {
              name: '桥梁巡检',
              image: 'https://hr2.chnsoft.com.cn/img/桥梁巡检.jpg',
              description: '对桥梁结构进行全面巡查，识别表面裂缝、混凝土剥落、钢结构锈蚀等问题，监测位移和变形情况，确保桥梁的安全性和稳定性。',
            },
            {
              name: '隧道巡检',
              image: 'https://hr2.chnsoft.com.cn/img/隧道巡检.jpg',
              description: '无人机检测隧道衬砌的裂缝、空洞、渗漏水等病害，监测通风、照明设施运行状态，及时发现并报告安全隐患，保障隧道安全。',
            },
            {
              name: '应急响应',
              image: 'https://hr2.chnsoft.com.cn/img/应急响应.jpg',
              description: '在突发事件中，如地震、火灾、洪水等，无人机快速抵达现场，实时传输画面，为应急救援决策提供关键数据支持，提升响应效率。',
            },



          ]
          break;
        case 'industry_other_2':
          this.activeTab = 0
          this.tabs = [
            {
              name: '常态巡逻',
              image: 'https://hr2.chnsoft.com.cn/img/常态巡逻图.jpg',
              description: '华软地空协同智能航空站（自动机场），为边海防常态巡逻提供有力支撑。高频次放飞巡逻无人机，凭借高清及热成像技术，广域监控边境海疆。航空站集群协同运作，智能分析监测数据，敏锐察觉异常，极大提升巡逻效能与精准度。',
            },
            {
              name: '边境冲突',
              image: 'https://hr2.chnsoft.com.cn/img/边境冲突.jpg',
              description: '面临边境冲突，华软地空协同智能航空站（自动机场）即刻响应。从航空站起飞的无人机实时回传高清现场影像，协助指挥中心洞悉态势。无人机配备的喊话、照明等功能模块，可远程威慑警示。借助智能全域巡视系统，增强冲突应对的决策与反应能力。',
            },
            {
              name: '反恐维稳',
              image: 'https://hr2.chnsoft.com.cn/img/反恐维稳.jpg',
              description: '华软无人装备指挥车放飞无人机高空隐蔽侦察，迅速掌握恐怖分子行踪。多无人机、四足机器人灵活部署，协同配合。智能全域巡视系统整合多方信息，实现多装备高效联动，为反恐力量提供全方位支持，提升处置效率与安全性。',
            },
            {
              name: '缉私缉毒',
              image: 'https://hr2.chnsoft.com.cn/img/缉私缉毒.png',
              description: '华软地空协同智能航空站（自动机场）、海空协同无人船及移动航空站，凭借高机动性助力边海防缉私缉毒。调控的无人机搭载先进探测设备，精准识别可疑车船。智能全域巡视系统快速处理数据，锁定目标，协助执法人员及时拦截，有力打击走私、贩毒行径。',
            },
            {
              name: '岸舰运输',
              image: 'https://hr2.chnsoft.com.cn/img/岸舰运输.png',
              description: '华软海空协同无人船稳定航行、精准定位，在复杂海况下高效转运物资。无人机空中侦察，保障运输路线安全。通过智能管控，提升运输效率，降低人员风险，确保岸舰运输平稳顺畅。',
            },

          ]
          break;
        case 'industry_other_3':
          this.activeTab = 0
          this.tabs = [
            {
              name: '矿区勘察',
              image: 'https://hr2.chnsoft.com.cn/img/矿区勘察.jpg',
              description: '华软地空协同智能航空站（自动机场）配合无人机，快速覆盖广阔矿区。无人机搭载高精度测绘与探测设备，能精准获取地形地貌、地质结构等数据。依托华软智能大脑强大算力，实现数据快速分析与建模，为矿区规划与资源评估提供详尽可靠依据，高效助力矿区勘察工作。',
            },
            {
              name: '矿区巡逻',
              image: 'https://hr2.chnsoft.com.cn/img/矿区巡逻.jpg',
              description: '华软地空协同智能航空站（自动机场）凭借快速换电实现无人机高频出击，不间断对矿区全方位巡逻。无人机凭借高清摄像头，清晰捕捉矿区人员、车辆活动情况。借助 AI 智能分析，及时发现异常闯入、违规作业等行为，快速预警，保障矿区秩序与安全。',
            },
            {
              name: '安全监控',
              image: 'https://hr2.chnsoft.com.cn/img/安全监控.jpg',
              description: '华软集群式换电航空站凭借快速换电与双机交替作业。通过热成像与高清摄像设备，24小时监测矿区设备运行、边坡稳定等状况。利用算力与算法实时分析数据，快速察觉设备故障、山体滑坡隐患等安全问题，为矿区安全生产保驾护航。',
            },
            {
              name: '物料盘点',
              image: 'https://hr2.chnsoft.com.cn/img/物料盘点.jpg',
              description: '华软地空协同智能航空站（自动机场）在矿区物料盘点中，放飞无人机搭载激光雷达等设备，对物料堆进行快速扫描。结合智能算法，精确计算物料体积、重量等数据。相比人工盘点，效率更高、误差更小，实现物料信息实时精准掌握，助力矿区物料科学管理。',
            },

          ]
          break;
        case 'industry_other_4':
          this.activeTab = 0
          this.tabs = [
            {
              name: '大气监测',
              image: 'https://hr2.chnsoft.com.cn/img/大气监测.jpg',
              description: '华软垂起固定翼智能航空站，可为大航程固定翼无人机提供全天候维护与自动换电保障，根据监测需求智能生成无人机航线，放飞搭载高精度气体传感器的无人机，实时监测空气质量、快速识别污染物分布，输出精准大气环境数据。',
            },
            {
              name: '水体采样',
              image: 'https://hr2.chnsoft.com.cn/img/水体采样.jpg',
              description: '华软各型智能无人船配备自动化采样设备，适配海洋、江河、水库等各类水体环境。可高效精确采集水样并实时回传水质数据，助力水体污染源快速定位与溯源分析。',
            },
            {
              name: '环境监测',
              image: 'https://hr2.chnsoft.com.cn/img/环境监测.jpg',
              description: '华软地空协同智能航空站（自动机场）+陆空协同无人车（机器人）+智能无人船，构建全方位生态环境监测体系。覆盖大气、陆地与水域场景，提供高分辨率影像采集、样本采集及数据分析服务，为环境评估工作提供数据支撑。',
            },
            {
              name: '环保应急',
              image: 'https://hr2.chnsoft.com.cn/img/环保应急.jpg',
              description: '地空协同智能航空站（自动机场）+陆空协同无人车（机器人）+智能无人船，集成红外热成像、AI 视觉分析、采样检测等核心功能。针对突发环保事件可快速响应，实现海陆空一体化实时监控火灾态势、污染扩散动态及治理进度，为决策制定提供数据支撑，显著提升应急处置效率。',
            },

          ]
          break;
        case 'industry_other_5':
          this.activeTab = 0
          this.tabs = [
            {
              name: '常态巡逻',
              image: 'https://hr2.chnsoft.com.cn/img/常态巡逻.jpg',
              description: '华软地空协同智能航空站（自动机场）自动调度无人机，按规划航线对港口全域进行高频次巡航。站内储备多块电池，确保无人机24小时不间断作业。无人机搭载高清摄像头与热成像设备，清晰捕捉港口水域船只、码头设施的实时状况。航空站借助算力单元和智能算法，对回传数据快速分析，及时察觉异常，全方位保障港口日常安全。',
            },
            {
              name: '港口引航',
              image: 'https://hr2.chnsoft.com.cn/img/港口引航.jpg',
              description: '华软地空协同智能航空站（自动机场）为港口引航提供有力支持。航空站放飞的无人机，实时获取港口航道、船舶位置等关键信息，并快速回传至引航站。同时，航空站可与其港口设备协同，为引航员提供更全面、精准的数据参考，助力引航员做出更准确决策，大大提升引航的安全性与效率。',
            },
            {
              name: '货场管理',
              image: 'https://hr2.chnsoft.com.cn/img/货场管理.jpg',
              description: '华软地空协同智能航空站（自动机场）调度无人机，搭载高精度测绘与监测设备，快速扫描货场，精准掌握货物的数量、位置及存储状态。依托智能全域巡视系统，自动分析货场数据，实现库存实时盘点。若发现货物异常或违规作业，能及时预警，实现货场的智能化、精细化管理。',
            },
            {
              name: '应急处置        ',
              image: 'https://hr2.chnsoft.com.cn/img/应急处置.png',
              description: '港口发生紧急情况时，华软地空协同智能航空站（自动机场）迅速响应。无人机即刻升空，利用高清及热成像设备，快速采集现场影像与数据，如火灾、泄漏等情况。航空站通过集群协同，将信息实时传输至指挥中心，并结合智能算法辅助制定科学的应急策略。同时，可调度华软陆空协同陆空协同无人消防车等其他无人设备协同作业，极大提升应急处置效率。',
            },


          ]
          break;
        case 'industry_other_6':
          this.activeTab = 0
          this.tabs = [
            {
              name: '工地勘查',
              image: 'https://hr2.chnsoft.com.cn/img/工地勘察.jpg',
              description: '华软移动航空站放飞无人机，搭载高精度测绘与成像设备，快速获取工地地形地貌、周边环境等详细数据。通过集群协同，多视角全方位扫描，数据实时回传并经算力单元快速处理分析，生成精准勘查报告，为施工规划提供可靠依据，大幅缩短勘查周期。',
            },
            {
              name: '安全管理 ',
              image: 'https://hr2.chnsoft.com.cn/img/安全管理.jpg',
              description: '华软无人值守换电式智能航空站高强度放飞无人机对工地进行24小时不间断监测。借助高清摄像头与智能分析系统，可及时发现未戴安全帽、违规操作等安全隐患。一旦察觉异常，立即预警，实现远程监管，降低安全事故风险，保障工地人员与施工安全。',
            },
            {
              name: '进度管理',
              image: 'https://hr2.chnsoft.com.cn/img/施工进度管理.jpg',
              description: '华软地空协同智能航空站（自动机场）为进度管理提供有力支持。无人机定期从航空站升空，拍摄工地施工画面。智能平台结合图像识别技术，对比施工计划与实际进度，精确分析各区域施工进展。直观呈现进度偏差，便于管理人员及时调整资源分配，确保工程按计划推进，按时交付。',

            },
            {
              name: '设计选址',
              image: 'https://hr2.chnsoft.com.cn/img/设计施工和选址.jpg',
              description: '华软移动航空站调度无人机，对多个潜在选址区域进行全面勘查。无人机搭载的设备收集地形、地质、周边交通等多维度信息，经智能平台整合分析，生成详细评估报告。为设计师提供全面、准确的数据支撑，辅助选出最优设计选址，节省时间与人力成本。',
            },
          ]
          break;



        case 'industry_uav_safe':
          this.activeTab = 0
          this.tabs = [
            {
              name: '活动安保',
              image: 'https://hr2.chnsoft.com.cn/img/活动安保.jpg',
              description: '在大型集会、赛事活动等人群密集、人流量大的场景，华软无人装备指挥车、移动航空站、无人机系留供电系统等在区域巡查持续性、巡查效率、巡查准确度等方面全面领先于传统人工巡查、摄像头监控、飞手遥控无人机等传统方式。',
            },
            {
              name: '警情处置',
              image: 'https://hr2.chnsoft.com.cn/img/警情处置.png',
              description: '华软地空协同智能航空站（自动机场）系列产品及智能全域巡视系统，全天候保障巡视无人机、机器人处于最佳出击状态，在日常巡逻或接到警情后，第一时间对场景和人员进行识别、跟踪、取证、留存证据，配合警方及时、高效完成警情处置任务。',
            },
            {
              name: '交通监管',
              image: 'https://hr2.chnsoft.com.cn/img/交通监管.jpg',
              description: '华软地空协同智能航空站（自动机场）系列产品及智能全域巡视系统，全天候保障无人机处于最优作业状态，自动控制无人机执行道路巡查、高峰时段和路段持续监控、拥堵疏导、违法取证等任务，助力交管部门提高交通监管效率。',
            },
            {
              name: '治安巡防',
              image: 'https://hr2.chnsoft.com.cn/img/治安巡防.jpg',
              description: '边境线、水库电站、油气管道等复杂地形全天候无人巡检，降低巡查风险；',
            },
            {
              name: '追踪侦察',
              image: 'https://hr2.chnsoft.com.cn/img/追踪侦察.jpg',
              description: '城市街道、社区、工业园区等区域存在大量巡检巡查需求，以保障生产生活秩序。传统人员巡查、固定摄像头、飞手遥控无人机等手段，存在人员需求大、覆盖范围小、监控死角多、巡飞效率低等问题。华软地空协同智能航空站（自动机场）系列产品及智能全域巡视系统，可全自动开展无人机维保、巡查、识别、留存、报告生成等各项任务，降低人员投入，显著提升作业效率。',
            },
          ]
          break;
        case 'industry_uav_forest':
          this.activeTab = 0
          this.tabs = [
            {
              name: '盗猎与入侵监控',
              image: 'https://hr2.chnsoft.com.cn/img/盗猎与入侵监控.jpeg',
              description: '华软地空协同智能航空站（自动机场），为自然保护区提供全天候无人机维护、自动起降与任务规划服务。通过AI 识别非法人员入侵并自动报警，降低巡逻人员及车辆对野生动物的干扰，24小时无死角守护生态安全。',
            },
            {
              name: '林火早期防控 ',
              image: 'https://hr2.chnsoft.com.cn/img/林火早期防控.jpeg',
              description: '华软地空协同智能航空站（自动机场），可为大航程固定翼无人机或旋翼无人机，提供全天候维护及自动换电保障。根据火灾高发季节与多发区域，自动生成动态巡查航线，无人机结合红外热成像技术第一时间捕捉火灾苗头。联动消防航空站，高效、高频放飞无人机精准投放灭火弹，将林火消灭在萌芽阶段。',
            },

            {
              name: '失踪人员搜救',
              image: 'https://hr2.chnsoft.com.cn/img/失踪人员搜救.png',
              description: '森林区域广袤、通行受阻，人员走失后搜救难度极大。华软地空协同智能航空站（自动机场）可保障大航程固定翼无人机或旋翼无人机随时放飞，搭载热成像设备快速开展大范围搜索。快速换电技术支持高强度不间断作业，不错过黄金救援时间。',
            },
            {
              name: '紧急物资投送',
              image: 'https://hr2.chnsoft.com.cn/img/紧急物资投送.jpg',
              description: '森林地区道路稀缺，若遭遇火灾、洪水、泥石流等灾害导致道路中断，救援与物资投递将受极大限制。华软大载重地空协同智能航空站（自动机场），凭借快速换电与补充挂载功能可不间断高强度起降无人机，跨越森林、山地等复杂地形，精准递送应急药品、通信器材等急需物资。',
            },


          ]
          break;



        case 'industry_uav_water':
          this.activeTab = 0
          this.tabs = [
            {
              name: '水库大坝巡查',
              image: 'https://hr2.chnsoft.com.cn/img/sk.png',
              description: '华软地空协同智能航空站（自动机场）搭配无人机，自动规划航线，凭借高清与热成像摄像头，全方位巡检水库大坝。凭借行业大模型与华软智能大脑卓越算力支持，快速识别结构隐患、异常渗漏等问题，实现24小时高效、精准的无人化监测，保障大坝安全。',
            },
            {
              name: '河湖岸线巡检 ',
              image: 'https://hr2.chnsoft.com.cn/img/an.jpg',
              description: '华软海空协同无人船放飞无人机：无人船贴岸线航行，无人机俯瞰全局，搭载多样监测设备。智能全域巡视系统集群协同精准调度，能迅速发现非法排污、非法采砂、侵占岸线等违法行为，高效守护河湖生态环境。',
            },
            {
              name: '水质与污染源监测',
              image: 'https://hr2.chnsoft.com.cn/img/无人船监测水质与污染源.png',
              description: '华软海空协同无人船配备专业检测设备，对水质进行实时在线监测；搭配无人机空中辅助，扩大监测范围；依托华软智能大脑快速分析数据，锁定污染源，为水质保护与治理提供有力数据支撑。',
            },
   
          ]
          break;
        case 'industry_uav_delivery':
          this.activeTab = 0
          this.tabs = [
            {
              name: '紧急物资空中递送',
              image: 'https://hr2.chnsoft.com.cn/img/uavJinJi.jpg',
              description: '华软地空协同智能航空站（自动机场）搭配大载重无人机，能突破地形限制，快速规划最优航线。凭借自动换电与自动装载技术保障高强度作业，实现24小时不间断飞行。可精准空投各类紧急物资，如医疗用品、救灾物资等，高效、及时满足应急需求。',
            },
            {
              name: '野外物资运送',
              image: 'https://hr2.chnsoft.com.cn/img/无人车野外物资运送.jpg',
              description: '华软智能无人车采用履带式越野底盘，适应复杂野外路况。无需人工驾驶，自主规划路径，稳定运送物资。搭配智能全域巡视系统，可实时监控调度，且能与无人机协同，提高运输效率，可靠完成野外物资运送任务。',
            },
            {
              name: '海上物资补给',
              image: 'https://hr2.chnsoft.com.cn/img/无人船海上物资补给.jpg',
              description: '华软海空协同无人船具备良好海上航行性能，搭配无人机精准定位引导。可携带各类物资，不惧风浪，稳定驶向目标船只。实现自动化补给，有效解决海上物资补给难题，保障海上作业持续进行。',
            },
    
          ]
          break;
        case 'industry_guan_wang':
          this.activeTab = 0
          this.tabs = [
            {
              name: '高空管网无人机巡检',
              image: 'https://hr2.chnsoft.com.cn/img/guan.jpg',
              description: '华软地空协同智能航空站（自动机场）搭配无人机，快速升空对高空管网全方位巡检。无人机搭载高清摄像头与热成像设备，清晰捕捉管网连接点、管道磨损等细节。通过AI算法智能分析巡检数据，迅速定位隐患，高效保障高空管网安全。',
            },
            {
              name: '地下管网机器人探测 ',
              image: 'https://hr2.chnsoft.com.cn/img/地下管网机器人探测.jpg',
              description: '针对地下管网，华软专用机器人灵活穿梭。它们配备多种探测传感器，能精准检测管道变形、破裂及堵塞情况。机器人自主作业，通过实时数据传输，将地下管网状况清晰呈现，助力运维人员快速决策，保障地下管网稳定运行。',
            },
            {
              name: '长距离管道自主巡线',
              image: 'https://hr2.chnsoft.com.cn/img/长距离管道自主巡线.jpg',
              description: '华软移动航空站与垂起固定翼智能航空站，胜任长距离管道巡线。无人机依预设航线自主飞行，利用先进导航与探测技术，沿途监测管道安全。集群协同可覆盖更广区域，快速发现管道周边异常，确保长距离管道全段安全无忧。',
            },
            {
              name: '危险区域应急排查',
              image: 'https://hr2.chnsoft.com.cn/img/危险区域应急排查.jpg',
              description: '在危险管网区域，地空协同智能航空站（自动机场）随时响应。放飞无人机搭载气体检测仪等设备，远程探测有毒有害气体。通过实时影像与数据回传，为指挥中心提供准确信息，辅助制定应急方案，保障人员安全，高效完成危险区域排查。',
            },
          ]
          break;
        case 'industry_gong_lu':
          this.activeTab = 0
          this.tabs = [
            {
              name: '公路养护',
              image: 'https://hr2.chnsoft.com.cn/img/公路养护.jpg',
              description: '华软地空协同智能航空站（自动机场）搭配无人机，能快速巡检公路路段。凭借高清摄像头与传感器，精准识别路面裂缝、坑洼、排水堵塞等问题。通过华软智能大脑分析数据，定位问题程度与位置，为养护决策提供科学依据，高效规划养护任务，延长公路使用寿命。',
            },
            {
              name: '应急救援 ',
              image: 'https://hr2.chnsoft.com.cn/img/应急救援.jpg',
              description: '公路突发事故时，华软地空协同智能航空站（自动机场）第一时间放飞无人机赶往事发地点。搭载热成像与高清设备，快速勘察现场，获取事故全貌、人员车辆位置等信息。实时回传数据，为指挥中心制定救援策略提供直观依据，助力高效调配资源，提升应急救援效率。',
            },
            {
              name: '交通疏导',
              image: 'https://hr2.chnsoft.com.cn/img/交通疏导.jpg',
              description: '移动航空站调度无人机实时监测交通流量。通过高清摄像头掌握拥堵路段状况，利用智能算法分析交通态势。及时将信息反馈给指挥中心，辅助制定疏导方案，引导车辆分流，缓解交通压力，保障道路畅通。',
            },
            {
              name: '施工监管',
              image: 'https://hr2.chnsoft.com.cn/img/施工监管.jpg',
              description: '华软移动航空站放飞无人机对公路施工现场全方位监管。搭载喊话器可远程提醒施工人员规范作业，利用摄像头记录施工进度与质量。实时传输影像至管理平台，方便管理人员远程监督，确保施工按标准进行，保障工程质量与安全。',
            },
          ]
          break;
        case 'industry_tie_lu':
          this.activeTab = 0
          this.tabs = [
            {
              name: '沿线巡检',
              image: 'https://hr2.chnsoft.com.cn/img/沿线巡检.jpg',
              description: '华软地空协同智能航空站（自动机场）调度无人机沿铁路线高频次巡检。凭借高清成像与智能识别技术，快速捕捉铁轨磨损、扣件松动等细微变化。集群作业覆盖范围广，结合强大算力分析，精准定位隐患，为铁路安全运营筑牢防线。',
            },
            {
              name: '树障巡检 ',
              image: 'https://hr2.chnsoft.com.cn/img/树障巡检.jpg',
              description: '移动航空站搭配无人机，灵活穿梭于铁路沿线。通过热成像及高清摄像头，清晰判别树木与铁路设施的距离。依托行业大模型，自动识别树障风险，提前预警，及时除障，避免树障影响铁路运行安全。',
            },
            {
              name: '设施巡检',
              image: 'https://hr2.chnsoft.com.cn/img/设施巡检.jpg',
              description: '华软移动航空站放飞无人机搭载专业检测设备，针对铁路桥梁、隧道、信号塔等设施巡检。借助智能算法，全方位检测设施结构完整性、表面损伤等情况。实时回传数据并深度分析，确保铁路设施稳定运行，保障行车安全。',
            },
            {
              name: '灾害响应',
              image: 'https://hr2.chnsoft.com.cn/img/灾害响应.jpeg',
              description: '铁路遇灾害时，华软地空协同智能航空站（自动机场）第一时间放飞无人机，快速采集受灾区域图像与数据。基于华软智能全域巡视系统，生成详细灾情报告，为指挥中心提供决策支持，助力快速制定救援与修复方案，高效恢复铁路通行。',
            },
          ]
          break;
        case 'industry_di_tie':
          this.activeTab = 0
          this.tabs = [
            {
              name: '隧道检测',
              image: 'https://hr2.chnsoft.com.cn/img/隧道检测.jpg',
              description: '华软地空协同智能航空站（自动机场）调度无人机深入地铁隧道。其搭载高清摄像与激光扫描设备，快速捕捉隧道壁裂缝、渗漏等状况。依托强大算力单元，智能分析数据，精准定位问题，高效完成隧道全方位检测，保障隧道结构安全。',
            },
            {
              name: '轨道检测	',
              image: 'https://hr2.chnsoft.com.cn/img/轨道检测.jpg',
              description: '华软空地一体智能巡查工务车沿地铁轨道细致巡检。凭借高精度传感器，精确测量轨道磨损、变形等参数。借助智能算法实时分析，快速发现潜在轨道隐患，为轨道维护提供科学依据，确保列车平稳运行。',
            },
            {
              name: '弓网检测',
              image: 'https://hr2.chnsoft.com.cn/img/弓网检测.jpeg',
              description: '华软地空协同智能航空站（自动机场）调度无人机针对地铁弓网系统开展检测。通过高速高清摄像技术，清晰记录弓网接触状态。结合专业分析软件，准确判断弓网磨损、打火等异常，及时预警，保障弓网系统可靠供电，避免供电故障。',
            },
            {
              name: '设施检测',
              image: 'https://hr2.chnsoft.com.cn/img/设施检测.jpeg',
              description: '华软地空协同智能航空站（自动机场）调度的无人机搭载多种检测设备，对地铁车站及沿线设施全面检测。从照明、通风到各类机电设备，均能快速排查故障隐患。利用智能平台整合数据，生成详细报告，助力运维人员及时维护，保障地铁设施稳定运行。',
            },
          ]
          break;
        case 'industry_hai_yang':
          this.activeTab = 0
          this.tabs = [
            {
              name: '海洋牧场',
              image: 'https://hr2.chnsoft.com.cn/img/海洋牧场.jpg',
              description: '华软海空协同无人船是海洋牧场的智能管家。它能自主巡航，搭载水质检测、生物探测等设备，实时监测海洋牧场水质、生物种群动态。同时，无人船支持无人机起降，二者协同，无人机高空俯瞰获取大面积信息，助力精准投喂、病害防控，提升海洋牧场智能化管理水平，保障产量与质量。',
            },
            {
              name: '近海巡检 ',
              image: 'https://hr2.chnsoft.com.cn/img/近海巡检.jpg',
              description: '华软海空协同无人船高效守护近海区域。船载多种探测设备，可监测海水污染、非法侵入等情况。无人机从船上起飞，扩大巡检范围，凭借高清成像快速识别目标。海空数据实时回传、智能分析，及时发现并预警异常，有力维护近海生态与资源安全。',
            },
            {
              name: '航道巡查',
              image: 'https://hr2.chnsoft.com.cn/img/航道巡查.jpg',
              description: '华软海空协同无人船为航道安全提供保障。无人船利用声呐等设备探测航道水深、水下障碍物，无人机升空查看航道水面状况，如船舶通行、漂浮物等。通过海空协同作业，全面掌握航道信息，及时反馈问题，确保航道畅通，提升船舶航行安全性。',
            },
            {
              name: '危险区域应急排查',
              image: 'https://hr2.chnsoft.com.cn/img/危险区域应急排查.jpg',
              description: '面对海洋危险区域，华软海空协同无人船优势凸显。无人船搭载检测设备靠近危险区域，实时检测有毒有害气体、辐射等数据。无人机升空，利用热成像和高清摄像头获取现场画面。二者协同作业，快速排查危险区域，为应急决策提供准确信息，保障人员安全。',
            },
            {
              name: '海上风电',
              image: 'https://hr2.chnsoft.com.cn/img/海上风电.jpg',
              description: '华软海空协同无人船服务海上风电运维。船载专业检测工具，对风电基础进行检测，如冲刷、腐蚀情况。无人机可检查风机叶片、塔筒等设备。二者相互配合，全方位监测风电设施，及时发现故障隐患，提高运维效率，降低运维成本，保障海上风电稳定运行。',
            },
            {
              name: '海上光伏',
              image: 'https://hr2.chnsoft.com.cn/img/海上光伏.png',
              description: '华软海空协同无人船放飞无人机，无人机在空中对光伏板表面及线路展开细致巡检，精准捕捉线路故障、电池板表面裂痕等可见问题。无人船搭载专业检测设备，贴近光伏板背板，检测其磨损、老化等隐患。二者各司其职又紧密协同，构建起全方位的巡检体系，确保海上光伏项目稳定运行。',
            },
          ]
          break;


        default:
          this.tabs = [
            {
              name: '设备巡检',
              image: 'https://hr2.chnsoft.com.cn/img/设备巡检.png',
              description: '嫌疑人/车辆动态锁定，结合人脸识别、车牌识别技术实现跨区域协同围捕',
            },
            {
              name: '红外测温',
              image: 'https://hr2.chnsoft.com.cn/img/红外测温.jpg',
              description: '实时监测电缆运行状态，预警潜在故障，保障电力供应安全',
            },
            {
              name: '表计识别',
              image: 'https://hr2.chnsoft.com.cn/img/表计识别.jpg',
              description: '精准定位树障位置，提供治理建议，提升电网运行效率',
            },
            {
              name: '应急处置        ',
              image: 'https://hr2.chnsoft.com.cn/img/应急处置.png',
              description: '实时影像判断树木对线路影响状况，预判风险',
            },
          ]
          break;
      }
    },
    handleTabClick(index) {
      // 先清空当前图片
      // if (this.tabs[this.activeTab]) {
      //   this.tabs[this.activeTab].image = '';
      // }
      // 再切换tab
      this.activeTab = index;
      // 重新赋值图片（如果需要的话，可以根据实际情况调整）
      this.$nextTick(() => {
        // 这里假设tabs数据没有变动，图片路径还是原来的
        // 如果tabs会变动，可以在这里重新赋值图片
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.application-scenario {
  text-align: center;
  /* padding: 0PX 18.75%; */
  border-radius: 8PX;
  margin-bottom: 80PX;
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80PX;
}

.title {
  margin: 80PX 0PX 40PX;
  font-family: PingFang SC;
  font-size: 32PX;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  color: #1E242A;
}

.tabs {
  display: flex;
  justify-content: center;
  /* 居中显示 */
  margin-bottom: 40PX;
  gap: 40PX;
  /* 小项间隔40PX */
  /* padding: 0 20%; */
}

.tabs button {
  /* flex: 1;  移除，让按钮宽度自适应内容 */
  display: inline-block;
  /* 新增，使按钮宽度与内容一致 */
  padding: 10PX 0;
  border: none;
  background-color: transparent;
  font-family: PingFang SC;
  font-size: 18PX;
  
  color: #6C757D;
  cursor: pointer;
  transition: color 0.3s, border-bottom 0.3s;
  border-bottom: 2PX solid transparent;
}

.tabs button.active {
  color: #0f6bf6;
  font-weight: bold;
  border-bottom: 2PX solid #0f6bf6;
}

.tab-content {
  position: relative;
  height: 640PX;
  overflow: hidden;
  /* 新增，超出部分隐藏 */
}

.tab-content img {
  width: 100%;
  /* 新增，宽度100% */
  /* height: 640PX; */
  /* 保持高度640PX */
  /* object-fit: cover; */
  /* 新增，超出部分隐藏且不压缩画质 */
  height: auto;
  background-size: cover;
  background-position: center;
  border-radius: 8PX;
}

.tab-content p.text {
  font-size: 16PX;
  color: #fff;
  text-align: center;
  position: absolute;
  /* 改为绝对定位 */
  bottom: 0PX;
  /* 移动到图片下部 */
  left: 50%;
  /* 水平居中 */
  transform: translateX(-50%);
  /* 调整居中对齐 */
  margin: 0;
  /* 移除多余的外边距 */
  z-index: 20;
  background: linear-gradient(1deg, rgba(30, 36, 42, 0.6) 12%, rgba(30, 36, 42, 0) 83%);
  // height: 120PX;
    padding: 20px 40px;
  /* line-height: 80PX; */
  width: 100%;
  border-radius: 8PX;
  /* 可选：让背景不超出图片区域 */
  box-sizing: border-box;
  left: 0;
  transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
